import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { RequireAuth } from "@/components/RequireAuth";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import AddListing from "@/pages/AddListing";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import Seller from "@/pages/Seller";

function AppRouter() {
  const location = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/seller/:id" element={<Seller />} />
      <Route path="/auctions" element={<Browse type="auction" />} />
      <Route path="/sale" element={<Browse type="sale" />} />
      <Route path="/rent" element={<Browse type="rent" />} />
      <Route path="/jobs" element={<Browse type="job" />} />
      <Route path="/invest" element={<Browse type="invest" />} />
      <Route path="/listing/:id" element={<ListingDetail />} />
      <Route path="/add" element={<RequireAuth><AddListing /></RequireAuth>} />
      <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="/admin" element={<RequireAuth admin><Admin /></RequireAuth>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App" dir="rtl">
      <BrowserRouter>
        <SiteProvider>
          <AuthProvider>
            <Header />
            <main className="flex-1"><AppRouter /></main>
            <Footer />
            <Toaster position="top-center" richColors dir="rtl" />
          </AuthProvider>
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
